
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.57119 8.05694C5.29405 9.53479 6.49198 10.7273 7.9731 11.4434C8.08147 11.4948 8.20134 11.517 8.32092 11.508C8.44049 11.4989 8.55565 11.4589 8.65506 11.3918L10.8359 9.93757C10.9324 9.87325 11.0433 9.83402 11.1588 9.82341C11.2742 9.81281 11.3905 9.83117 11.497 9.87683L15.577 11.6254C15.7156 11.6843 15.8313 11.7866 15.9067 11.9169C15.9821 12.0473 16.0131 12.1986 15.995 12.3481C15.866 13.3572 15.3737 14.2847 14.6101 14.9569C13.8466 15.6291 12.8642 15.9999 11.8469 16C8.70491 16 5.6916 14.7518 3.46988 12.5301C1.24815 10.3084 0 7.29509 0 4.1531C5.34927e-05 3.13581 0.370907 2.15342 1.04312 1.38988C1.71533 0.626332 2.64281 0.133988 3.65189 0.00503162C3.80139 -0.0130594 3.95271 0.0179227 4.08306 0.0933102C4.21342 0.168698 4.31574 0.284407 4.37461 0.423003L6.12469 4.50651C6.16996 4.61214 6.1884 4.72732 6.17838 4.84179C6.16836 4.95627 6.13019 5.06649 6.06726 5.16265L4.61807 7.37695C4.55211 7.47656 4.51312 7.59157 4.5049 7.71076C4.49668 7.82994 4.51952 7.94922 4.57119 8.05694Z"}})])
          )
        }
      }
    